import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router'
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import configureStore, { history } from "./store/configureStore";
import App from './app'; 


const store = configureStore; 
window.store = store;

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);
unregister();
//registerServiceWorker();